import axios from 'axios'
import Compress from 'compress.js'
import { isEmpty } from 'lodash'
import {
    createPatternFromImageNew,
    toBase64,
    toThumbnail64,
} from '../helper/fileHelper'

export const baseURL = 'http://api.mokabber.com/'
export const baseShareURL = 'http://app.mokabber.com'

const productsBaseURL='http://localhost:51888';
axios.defaults.baseURL = baseURL

export const setAxiosHeader = (token) => {
    axios.defaults.headers.common = { Authorization: `Bearer ${token}` }

    //axios.defaults.headers.common = { Authorization: `Basic ck_3db8b87a927dddc3dddf0e279915c90d90e8c2e0:cs_f6c2e509dedf4523fc8eeb363323434844937cd8` }
}

const productAPI = axios.create({
    baseURL: 'https://mokabber.com/wp-json/wc/v3',
    
})

export default {
    materials: {
        getOne: ({ id }) =>
            productAPI.get(`/products/${id}`, {
                params: {
                    consumer_key : `ck_3db8b87a927dddc3dddf0e279915c90d90e8c2e0`,
                    consumer_secret: `cs_f6c2e509dedf4523fc8eeb363323434844937cd8`,
                },
            }),
        getAll: (pageNumber = 1, searchText) => {
            const urlParams = new URLSearchParams()
            urlParams.append('page', pageNumber);

            urlParams.append('per_page', 50);

            if (searchText) urlParams.append('searchTerm', searchText)
            return productAPI.get(`/products?${urlParams.toString()}`, {
                params: {
                    consumer_key : `ck_3db8b87a927dddc3dddf0e279915c90d90e8c2e0`,
                    consumer_secret: `cs_f6c2e509dedf4523fc8eeb363323434844937cd8`,
                },
            })
        },
        update: (id, toUpdate) => axios.put(`/api/Fabric/${id}`, toUpdate),
        updateImage: async ({ id, file, patternFlipH, patternFlipV }) => {
            const patternFile = await createPatternFromImageNew(
                file,
                100,
                400,
                patternFlipH,
                patternFlipV
            )
            // const thumbnailDataUrl = await toThumbnail64(patternFile)
            return axios.post(
                '/api/product/UploadAppThumbnail',
                {
                    imageData: patternFile,
                    productId: id,
                },
                {
                    baseURL: productsBaseURL,
                }
            )
        },
        resetEditedImage: (id) =>
            axios.delete(`/api/product/removeAppThumbnail/${id}`, {
                baseURL: productsBaseURL,
            }),
        create: async ({ title, file }) => {
            const { imageData, thumbnailDataUrl } = await toBase64(file)
            return axios.post('/api/Fabric', {
                imageData,
                title,
                thumbnailData: thumbnailDataUrl,
            })
        },
        delete: ({ id }) => axios.delete(`/api/Fabric/${id}`),
    },
    rooms: {
        getOne: (id) => axios.get(`/api/Project/${id}`),
        getAll: () => axios.get('/api/Project'),
        update: (id, toUpdate) => axios.put(`/api/Project/${id}`, toUpdate),
        updateImage: async ({ id, file }) => {
            const thumbnailDataUrl = await toThumbnail64(file)

            return axios.post('/api/Media?fromEditor=true', {
                entityId: id,
                entity: 'Project',
                imageDataUrl: file,
                thumbnailDataUrl,
            })
        },
        create: async ({ title, file }) => {
            const { imageData, thumbnailDataUrl } = await toBase64(file)
            return axios.post('/api/Project', {
                imageData,
                title,
                thumbnailData: thumbnailDataUrl,
            })
        },
        delete: ({ id }) => axios.delete(`/api/Project/${id}`),
    },
    auth: {
        register: (data) => axios.post('/api/Authentication/register', data),
        login: (data) => axios.post('/api/Authentication/login', data),
        // TODO:??
        refreshToken: () => axios.get(),
        forgotPasswordStepOne: (mobile) =>
            axios.post(
                `/api/Authentication/RequestForgotPsswordToken?userName=${mobile}`
            ),
        forgotPasswordStepTwo: (data) =>
            axios.post('/api/Authentication/ForgotPassword', data),
        resetPassword: (data) =>
            axios.post('/api/Authentication/ResetPassword', data),
        validateUser: (data) =>
            axios.post('/api/Authentication/validateAccount', data),
    },
    profile: {
        get: () => axios.get('/api/user'),
        getAddresses: (id) => axios.get(id),
        getProfilePicture: () => axios.get('/api/User/retrive-profile-photo'),
        uploadProfile: (file) => {
            const bodyFormData = new FormData()
            console.log('file', file)
            bodyFormData.append('image', file)
            return axios.post('/api/User/upload-profile', bodyFormData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        },
        uploadPlan: (file, roomId, fabricIds) => {
            const compress = new Compress()

            function dataURLtoFile(dataurl, filename) {
                const arr = dataurl.split(',')
                const mime = arr[0].match(/:(.*?);/)[1]
                const bstr = atob(arr[1])
                let n = bstr.length
                const u8arr = new Uint8Array(n)

                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, { type: mime })
            }

            return compress
                .compress([dataURLtoFile(file)], {
                    size: 1,
                    quality: 0.75,
                    resize: false,
                })
                .then((data) => {
                    return axios.post('/api/Post', {
                        relatedProjectId: roomId,
                        usedFabrics: fabricIds?.join(',') ?? '',
                        title: '',
                        imageData: 'data:image/png;base64,' + data[0].data,
                        isPublic: true,
                    })
                })
        },
        changeName: (firstName, lastName) =>
            axios.put('/api/User', {
                firstName: firstName,
                lastName: lastName,
            }),
    },
    plan: {
        getAll: ({ type, sort, filter, search, pageNumber }) => {
            if (type === 'my') return axios.get('/api/Post/my-posts')
            else if (type === 'favourite')
                return axios.get('/api/Post/marked-posts')

            const filters = []
            for (const id in filter) {
                if (Object.hasOwnProperty.call(filter, id)) {
                    const filterValues = filter[id].split(',')
                    filterValues.forEach((value) => {
                        filters.push({ id: id, value: value })
                    })
                }
            }

            const urlParams = new URLSearchParams()
            urlParams.append('pageNumber', pageNumber ?? 1)
            urlParams.append('pageSize', 15)
            if (search) urlParams.append('searchTerm', search)

            switch (sort) {
                case 'popular':
                    urlParams.append('orderBy', 'likesCount desc')
                    break
                case 'most-seen':
                    urlParams.append('orderBy', 'visitCount desc')
                    break
                case 'newest':
                    urlParams.append('orderBy', 'addedDate desc')
                    break

                default:
                    break
            }

            if (filters.length > 0) {
                return axios
                    .post(
                        '/api/Product/filter',
                        {
                            filters: filters,
                        },
                        {
                            baseURL: productsBaseURL,
                        }
                    )
                    .then((res) => {
                        const fabrics = res.data
                        return axios.post(
                            '/api/Post/search?' + urlParams.toString(),
                            isEmpty(fabrics) ? [0] : fabrics
                        )
                    })
            }

            return axios.post('/api/Post/search?' + urlParams.toString(), [])
        },
        getById: (id) => axios.get(`/api/Post/${id}`),
        getFabricsById: (id) =>
        productAPI.get(`/products/${id}`, {
            params: {
                consumer_key : `ck_3db8b87a927dddc3dddf0e279915c90d90e8c2e0`,
                consumer_secret: `cs_f6c2e509dedf4523fc8eeb363323434844937cd8`,
            },
        }),
        addComment: (planId, comment) =>
            axios.post('/api/comment', {
                postId: planId,
                text: comment,
            }),
        toggleLike: (planId) => axios.post(`/api/Post/like/${planId}`),
        toggleFavourite: (planId) => axios.post(`/api/Post/mark/${planId}`),
        togglePublic: (planId, value) =>
            axios.patch(`/api/Post/${planId}`, [
                {
                    value: value,
                    path: 'isPublic',
                    op: 'replace',
                    from: 'string',
                },
            ]),
        getFilters: () =>
            axios.get('/api/ProductFeature', {
                baseURL: productsBaseURL,
            }),
    },
    payment: {
        submitOrder: (fabrics) =>
            axios.post('api/Order/submit', {
                wichFabricsHowMuchMeters: fabrics.map((q) => ({
                    fabricId: q.id,
                    meters: parseFloat(q.meterage),
                })),
            }),
    },
}
